import { Breadcrumb, Upload, Typography, Modal, Row, Col, Button, Space, Radio, Card, Input, Select, Checkbox, Switch } from 'antd';
import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { ExclamationCircleFilled, PlusOutlined } from '@ant-design/icons';
import PreviewImgModal from './Media/PreviewImgModal';
import axios from 'axios';
import AdminModal from './AdminModal';
const { Title, Paragraph, Text, Link } = Typography;
const { confirm } = Modal;
const { TextArea } = Input;
const AdminEnvironmentModal = (props) => {
    const [user_name, set_user_name] = useState([]);
    const handleOnEncode = (value) => {
        var tmp = "";
        for (var i = 0; i < value.length; i++) {
            if (value.charCodeAt(i) == 12288) {
                tmp += String.fromCharCode(value.charCodeAt(i) - 12256);
                continue;
            }
            if (value.charCodeAt(i) > 65280 && value.charCodeAt(i) < 65375) {
                tmp += String.fromCharCode(value.charCodeAt(i) - 65248);
            }
            else {
                tmp += String.fromCharCode(value.charCodeAt(i));
            }
        }
        props.setEditCard(prev_editcard => ({ ...props.editcard, capacity: tmp }))
    }
    useEffect(() => {
        axios
            .get('/cramSchool/api/surrounding/admin_list')
            .then((response) => {
                set_user_name(response.data.data.map((value) => {
                    return {
                        value: value.user_id,
                        label: value.name
                    }
                }))
            })
    }, [])
    return (
        <>
            <AdminModal
                {...props}
                title={(<>
                    <Col style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 53, left: 25 }} >{props.title}</Col>

                </>)}
                uploads
            >
                <Row gutter={[8, 8]} align={'middle'}>
                    <Col span={6}>環境名稱</Col>
                    <Col span={18}>
                        <Input rows={4} placeholder="請輸入環境標題或空間名稱" value={props.editcard.name} name="name" onChange={e => props.setEditCard(prev_editcard => ({ ...props.editcard, name: e.target.value }))} autoComplete="off" />
                    </Col>
                    <Col span={6}>容納人數</Col>
                    <Col span={10}>
                        <Input placeholder="請輸入最大容納人數" value={props.editcard.capacity} name="capacity" onChange={e => handleOnEncode(e.target.value)} autoComplete="off" />
                    </Col>
                    <Col span={1}>人</Col>
                    <Col span={7}></Col>
                    <Col span={6}>設備</Col>
                    <Col span={18}>
                        <Input placeholder="請輸入設備名稱" value={props.editcard.equipment} name="equipment" onChange={e => props.setEditCard(prev_editcard => ({ ...props.editcard, equipment: e.target.value }))} autoComplete="off" />
                    </Col>
                    <Col span={6}>管理員</Col>
                    <Col span={18}>
                        <Select
                            labelInValue
                            placeholder='請選擇管理員'
                            style={{ width: '100%' }}
                            value={props.editcard.user_name}
                            onChange={value => props.setEditCard(prev => ({
                                ...prev,
                                manage_user_id: value.value,
                                user_name: value.label
                            }))
                            }
                            options={user_name}
                        ></Select>
                    </Col>
                    <Col span={6}>
                        介紹內文
                    </Col>
                    <Col span={18}>
                        <TextArea rows={4} type='text' placeholder="請輸入環境介紹"
                            autoComplete="off"
                            value={props.editcard.note}
                            name="note" onChange={e => props.setEditCard(prev_editcard => ({ ...props.editcard, note: e.target.value }))} />
                    </Col>
                </Row>
            </AdminModal >
        </>
    )

}
export default AdminEnvironmentModal;